import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";

import { fetchWrapper } from "_helpers";
import { Slide, toast } from "react-toastify";

const res = {
  data: {
    result: [
      {
        rtv_number: "RTV00001",
        rtv_date: "2024-08-10",
        shipping_by_date: "2024-08-10",
        shipment_date: "2024-08-10",
        store_code: "100001",
        supplier_code: "1000001",
        rtv_status: 1,
        rtv_quantity: 10,
        rtv_cost: 100,
        shipment_quantity: 10,
        shipment_cost: 100,
        rtv_instruction: "nasdfj",
        rtv_signed_copy: "lkjlkjalsd",
        return_reason_code: "ABC01",
        return_reason_description: "alkjsdlfk",
        cancelled_remarks: "lkajsldjf",
        created_at: "2024-08-10T17:57:24.000Z",
        updated_at: "2024-08-10T17:57:33.000Z",
        poLocation: "Island Mart",
        ship_to: "123 SM MegamallEDSA corner Julia Vargas Avenue",
        store_city: "Mandaluyong City",
        store_state: null,
        store_country: "Philippines",
        store_zip: "1550",
        code: "100001",
        desc: "Island Mart",
        supplier_address: "123 Main Street Makati City",
        supplier_city: "Metro Manila",
        supplier_state: null,
        supplier_country: "Philippines",
        supplier_zip: "1229",
        total_cost: "100",
      },
    ],
    count: [
      {
        total: 1,
      },
    ],
  },
  success: true,
};

// create slice

const name = "rtv";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }; // Update Redux filters
    },
    clearFilter: (state, action) => {
      const { filterKey, value } = action.payload;
      const currentFilter = state.filters[filterKey];

      if (Array.isArray(currentFilter)) {
        // Remove only the specified value from the array
        state.filters[filterKey] = currentFilter.filter(
          (item) => item !== value
        );
        // If the array becomes empty, remove the filter key entirely
        if (state.filters[filterKey].length === 0) {
          delete state.filters[filterKey];
        }
      } else {
        // If it's not an array, simply delete the filter
        delete state.filters[filterKey];
      }
    },
    resetFilters: (state) => {
      state.filters = {}; // Reset all filters
    },
    resetData(state) {
      state.list.value.data = {
        currentPage: 0,
        rows: [],
        totalItems: 0,
        totalPages: 0,
      };
    },
  },
  extraReducers,
});

// exports

export const rtvActions = { ...slice.actions, ...extraActions };
export const rtvReducer = slice.reducer;
export const { setFilters, clearFilter, resetFilters, resetData } =
  slice.actions;

// implementation

function createInitialState() {
  return {
    list: {
      loading: true,
      value: {
        data: { currentPage: 0, rows: [], totalItems: 0, totalPages: 0 },
      },
    },
    filters: {},
    filterOptions: {},
    item: { loading: true },
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;

  return {
    getRtvAll: getRtvAll(),
    getRtvDetails: getRtvDetails(),
    getRtvFilterOptions: getRtvFilterOptions(),
  };

  function getRtvAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async ({
        pageId,
        page,
        pageSize,
        sortField,
        sortOrder,
        searchQuery,
        filters,
      }) => {
        let apiUrl = `${baseUrl}/rtv/getall?pageId=${pageId}&page=${page}&size=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&searchQuery=${searchQuery}`;
        apiUrl += filters?.createDate?.from
          ? `&startDate=${filters?.createDate?.from}`
          : "";
        apiUrl += filters?.createDate?.to
          ? `&endDate=${filters?.createDate?.to}`
          : "";
        apiUrl += filters?.rtvNumber?.length
          ? filters.rtvNumber.map((id) => `&rtvNumbers[]=${id}`).join("")
          : "";
        apiUrl += filters?.stores?.length
          ? filters.stores.map((id) => `&storeCodes[]=${id}`).join("")
          : "";
        apiUrl += filters?.vendors?.length
          ? filters.vendors.map((id) => `&vendorCodes[]=${id}`).join("")
          : "";
        return await fetchWrapper.get(apiUrl);
      }
    );
  }
  function getRtvDetails() {
    return createAsyncThunk(
      `${name}/rtvDetails`,
      async (id) => await fetchWrapper.get(`${baseUrl}/rtv/rtvDetails/${id}`)
    );
  }
  function getRtvFilterOptions() {
    return createAsyncThunk(
      `${name}/getRtvFilterOptions`,
      async ({ pageId }) =>
        await fetchWrapper.get(
          `${baseUrl}/rtv/getRtvFilterOptions?pageId=${pageId}`
        )
    );
  }
}
function createExtraReducers() {
  return (builder) => {
    getRtvAll();
    getRtvDetails();
    getRtvFilterOptions();
    function getRtvAll() {
      var { pending, fulfilled, rejected } = extraActions.getRtvAll;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          const exitstingRows = current(state).list.value.data.rows;
          state.list = {
            value: {
              data: {
                rows: [...exitstingRows, ...action?.payload?.data?.rows],
                totalItems: action?.payload?.data?.totalItems,
              },
            },
          };
          state.item = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          toast.error(
            <div>
              ❗ Something went wrong!
              <br /> Please try again later.
            </div>,
            {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Slide,
            }
          );
          state.list = {
            value: {
              data: {
                rows: [],
                totalItems: 0,
              },
            },
          };
          state.item = { loading: false };
        });
    }
    function getRtvDetails() {
      var { pending, fulfilled, rejected } = extraActions.getRtvDetails;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(rejected, (state, action) => {
          state.item = { value: res.data.result };
        });
      // .addCase(rejected, (state, action) => {
      //   state.item = { error: action.error };
      // });
    }
    function getRtvFilterOptions() {
      var { pending, fulfilled, rejected } = extraActions.getRtvFilterOptions;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        //! change to error
        .addCase(fulfilled, (state, action) => {
          state.filterOptions = action?.payload?.data;
          state.item = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          toast.error(
            <div>
              ❗ Something went wrong!
              <br /> Please try again later.
            </div>,
            {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Slide,
            }
          );
          state.filterOptions = {};
          state.item = { loading: false };
        });
    }
  };
}
